import type { SVGProps } from 'react'
const SvgWarningNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" width="58" height="58" rx="29" fill="#FCEAEA" />
    <path
      d="M17.5 39L29.5 19L41.5 39H17.5ZM19.7257 37.75H39.2743L29.5 21.5L19.7257 37.75ZM29.5 36.0194C29.7257 36.0194 29.9149 35.9456 30.0677 35.7981C30.2204 35.6506 30.2968 35.4679 30.2968 35.25C30.2968 35.0321 30.2204 34.8494 30.0677 34.7019C29.9149 34.5544 29.7257 34.4806 29.5 34.4806C29.2743 34.4806 29.0851 34.5544 28.9323 34.7019C28.7796 34.8494 28.7032 35.0321 28.7032 35.25C28.7032 35.4679 28.7796 35.6506 28.9323 35.7981C29.0851 35.9456 29.2743 36.0194 29.5 36.0194ZM28.8527 33.2306H30.1473V26.9806H28.8527V33.2306Z"
      fill="#E22828"
    />
  </svg>
)
export default SvgWarningNew
